import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Container,
} from "@mui/material";
import {
  Logout as LogoutIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import { AuthContext } from "../contexts/AuthContext";
import { logout } from "../services/auth";
import BookingManagement from "../components/BookingManagement";

function BookingAdmin() {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      navigate("/login");
    }
  }, [currentUser, navigate]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Errore durante il logout:", error);
    }
  };

  const handleBackToCms = () => {
    navigate("/cms");
  };

  if (!currentUser) {
    return null;
  }

  return (
    <>
      <AppBar position="static" elevation={2}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleBackToCms}
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>

          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "0.9rem", sm: "1.25rem" },
              display: { xs: "none", sm: "block" }
            }}
          >
            Gestione Prenotazioni - Ilaria Stumpo Coaching
          </Typography>

          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              fontSize: "0.9rem",
              display: { xs: "block", sm: "none" }
            }}
          >
            Prenotazioni
          </Typography>

          <Typography
            variant="body2"
            sx={{
              mr: 2,
              display: { xs: "none", md: "block" }
            }}
          >
            {currentUser.email}
          </Typography>

          <IconButton color="inherit" onClick={handleLogout}>
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container
        maxWidth="xl"
        sx={{
          py: { xs: 2, sm: 4 },
          px: { xs: 1, sm: 3 }
        }}
      >
        <BookingManagement />
      </Container>
    </>
  );
}

export default BookingAdmin;